import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

import { getImageUrlFromPath } from '@/lib/helpers/images';
import { fetchProviders } from '@/services/fetchProviders';
import { usePracticeStore } from '@/store/usePracticeStore';

export const DEFAULT_PROVIDER_IMAGE_URL = '84pii_provider-default-image.png';

export const useProviders = () => {
  const { providers, setProviders } = usePracticeStore();
  const { isFetching, data, error } = useQuery({
    queryKey: ['providers'],
    queryFn: fetchProviders,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data?.providers) {
      setProviders(
        data.providers.map((provider) => ({
          ...provider,
          provider_profile_image_url: getImageUrlFromPath(
            provider.provider_profile_image_url || DEFAULT_PROVIDER_IMAGE_URL,
          ),
        })),
      );
    }
  }, [data, setProviders]);

  useEffect(() => {
    if (data?.error) {
      toast.error(data?.error);
    }
  }, [data?.error]);

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error]);

  return {
    isFetching,
    providers,
  };
};
